module.exports = __webpack_public_path__ + "static/media/atm.48823056.png";